/**
 * Amounts are entered with 8 decimals, but an asset with fewer decimals can only
 * carry multiples of its own smallest unit. This checks an 8-decimal amount can
 * be expressed exactly, so nothing is silently rounded away when it is sent.
 */
export const isAmountRepresentable = (
  amount: bigint,
  decimals: number
): boolean => decimals >= 8 || amount % 10n ** BigInt(8 - decimals) === 0n;
